/* eslint-disable */
import React, { useEffect } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
// import Fade from 'react-reveal/Fade';
import { DataLayer } from '~/components/DataLayer';
import configData from '~/config/data';
import PosterPage from './PosterPage/PosterPage';
import MainPage from './MainPage/MainPage';
import LivePage from './LivePage/LivePage';
// import VdPage from './VdPage/VdPage';
import V360Page from './V360Page';
import WhatsappPage from './WhatsappPage';
import GalleryPage from './GalleryPage/GalleryPage';
import AboutPage from './AboutPage/AboutPage';
import FooterPage from './FooterPage/FooterPage';

const propTypes = {
	name: PropTypes.string,
	mobile: PropTypes.bool,
	data: PropTypes.object,
};

const defaultProps = {
	name: '',
	mobile: false,
	data: configData,
};

export const App = ({ data, ...props }) => {
	useEffect(() => {
		DataLayer.push('App_Iniciou', props.name);
	}, []);
	return (
		<div data-ui-section={true} id='Sections'>
			<PosterPage {...props} />
			<MainPage {...props} />
			<LivePage {...props} />
			<V360Page {...props} />
			<WhatsappPage {...props} />
			{/* <VdPage {...props} /> */}
			{!props.mobile && <GalleryPage {...props} />}
			<AboutPage {...props} />
			<FooterPage {...props} />
		</div>
	);
};

App.displayName = 'App';
App.propTypes = propTypes;
App.defaultProps = defaultProps;
export default App;
